import * as types from '../mutation-types'
const { findIndex } = require('@/plugins/lodash')
import { getOrderFeeDetail, cloneDeepArray } from '../../plugins/util'
import { CURRENCY_SYMBOL, ADVANCE_SETTING_SERVICES } from '../../mixins/constants'

function genKeyLatLng(lat, lng, index) {
  return `${lat}_${lng}_${index}`
}

const INITIAL_DATA_TRUCK = {
  path: [],
  selectedService: {},
  services: [],
  orderRequestsTruck: [],
  orderPromoCodeTruck: '',
  fee: {},
  isEstimatingFee: false,
  estimateFeeErrorMessage: '',
  showTotalFee: false,
  requests: [],
  orderTime: 0,
  useOrderTimeAsPickupTimeTruck: false,
  images: [],
  remarks: '',
  creatingOrderTruck: false,
  payment_method: undefined
}
const state = {
  ...INITIAL_DATA_TRUCK,
  prevPathOfOrderDetail: ''
}

// getters
const getters = {
  getPathTruck: (state) => state.path,
  getSelectedServiceTruck: (state) => state.selectedService,
  getServicesTruck: (state) => state.services,
  getOrderRequestsTruck: (state) => state.orderRequestsTruck,
  getOrderPromoCodeTruck: (state) => state.orderPromoCodeTruck,
  getFeeTruck: (state) => state.fee,
  getStatusEstimatingFeeTruck: (state) => state.isEstimatingFee,
  getEstimatFeeErrorMessageTruck: (state) => state.estimateFeeErrorMessage,
  getShowTotalFeeTruck: (state) => state.showTotalFee,
  getSelectedRequestsTruck: (state) => state.requests,
  getOrderImagesTruck: (state) => state.images,
  getOrderTimeTruck: (state) => state.orderTime,
  getUseOrderTimeAsPickupTimeTruck: (state) => state.useOrderTimeAsPickupTimeTruck,
  getOrderRemarksTruck: (state) => state.remarks,
  getStatusCreatingOrderTruck: (state) => state.creatingOrderTruck,
  getPrevPathOfOrderDetail: (state) => state.prevPathOfOrderDetail,
  getOrderPaymentMethodTruck: (state) => state.payment_method
}

// actions
const actions = {
  setPathDataTruck({ commit }, path) {
    path.forEach((p, index) => {
      p.key = genKeyLatLng(p.lat, p.lng, index)
    })
    commit(types.SET_PATH_DATA_TRUCK, path)
  },
  setServicesTruck({ commit }, allServices) {
    let services = []
    allServices.forEach((i) => {
      if (ADVANCE_SETTING_SERVICES.includes(i._id)) {
        services.push(i)
      }
    })
    commit(types.SET_SERVICES_TRUCK, services)
  },
  handleSelectServiceTruck({ commit }, service) {
    commit(types.UPDATE_ORDER_REQUEST_TRUCK, [])
    commit(types.SET_SERVICE_TRUCK, service)
  },
  updateFeeTruck({ commit }, fee) {
    let calcFeeDetail = getOrderFeeDetail(fee)

    calcFeeDetail.currency_symbol = CURRENCY_SYMBOL[fee.currency]
    commit(types.UPDATE_FEE_TRUCK, {
      ...fee,
      ...calcFeeDetail
    })
  },
  estimatingFeeTruck({ commit }, status) {
    commit(types.UPDATE_ESTIMATE_FEE_STATUS_TRUCK, status)
  },
  estimateFeeTruckError({ commit }, message) {
    commit(types.UPDATE_ESTIMATE_FEE_ERROR_MESSAGE_TRUCK, message)
  },
  addOrderRequestTruck({ commit, state }, request) {
    let requests = cloneDeepArray(state.requests)
    const index = findIndex(requests, (i) => i._id === request._id)

    if (index === -1) {
      requests.push(request)
    } else {
      requests.splice(index, 1, request)
    }
    commit(types.UPDATE_ORDER_REQUEST_TRUCK, requests)
  },
  removeOrderRequestTruck({ commit, state }, request) {
    let requests = cloneDeepArray(state.requests)
    const index = findIndex(requests, (i) => i._id === request._id)
    if (index !== -1) {
      requests.splice(index, 1)
      commit(types.UPDATE_ORDER_REQUEST_TRUCK, requests)
    }
  },
  addOrderImageTruck({ commit }, url) {
    let images = cloneDeepArray(state.images)
    images.push(...url)
    commit(types.ADD_ORDER_IMAGE_TRUCK, images)
  },
  removeOrderImageTruck({ commit }, url) {
    let images = cloneDeepArray(state.images)
    const index = findIndex(images, (i) => i === url)

    if (index !== -1) {
      images.splice(index, 1)
      commit(types.REMOVE_ORDER_IMAGE_TRUCK, images)
    }
  },
  updateOrderRemarksTruck({ commit }, value) {
    commit(types.UPDATE_ORDER_REMARKS_TRUCK, value)
  },
  setOrderTimeTruck({ commit }, payload) {
    commit(types.SET_ORDER_TIME_TRUCK, payload)
  },
  deletePointOfPathTruck({ commit }, index) {
    if (index > 0) {
      let path = cloneDeepArray(state.path)
      path.splice(index, 1)
      commit(types.DELETE_POINT_OF_PATH_TRUCK, path)
    }
  },
  creatingOrderTruck({ commit }, status) {
    commit(types.UPDATE_STATUS_CREATING_TRUCK, status)
  },
  resetDataTruck({ commit }) {
    commit(types.RESET_DATA_TRUCK)
  },
  reuseStateToCreateOrderTruck({ commit }, payload) {
    const newState = {
      ...INITIAL_DATA_TRUCK,
      path: payload.path
    }

    commit(types.REUSE_STATE_TO_CREATE_ORDER_TRUCK, newState)
  },
  setOrderPaymentMethod({ commit }, method) {
    commit(types.SET_ORDER_FORM_PAYMENT_METHOD_TRUCK, method)
  }
}

// mutations
const mutations = {
  [types.SET_PATH_DATA_TRUCK](state, path) {
    state.path = path
  },
  [types.SET_SERVICES_TRUCK](state, services) {
    state.services = services
  },
  [types.SET_SERVICE_TRUCK](state, service) {
    state.selectedService = service
  },
  [types.UPDATE_FEE_TRUCK](state, fee) {
    state.fee = fee
  },
  [types.UPDATE_ESTIMATE_FEE_STATUS_TRUCK](state, status) {
    state.isEstimatingFee = status
    if (!state.showTotalFee) {
      state.showTotalFee = true
    }
  },
  [types.UPDATE_ESTIMATE_FEE_ERROR_MESSAGE_TRUCK](state, message) {
    state.estimateFeeErrorMessage = message
  },
  [types.UPDATE_ORDER_REQUEST_TRUCK](state, requests) {
    state.requests = requests
  },
  [types.ADD_ORDER_IMAGE_TRUCK](state, images) {
    state.images = images
  },
  [types.REMOVE_ORDER_IMAGE_TRUCK](state, images) {
    state.images = images
  },
  [types.UPDATE_ORDER_REMARKS_TRUCK](state, remarks) {
    state.remarks = remarks
  },
  [types.SET_ORDER_TIME_TRUCK](state, payload) {
    state.orderTime = payload.time
    state.useOrderTimeAsPickupTimeTruck = payload.useOrderTimeAsPickupTimeTruck
  },
  [types.DELETE_POINT_OF_PATH_TRUCK](state, path) {
    state.path = path
  },
  [types.UPDATE_STATUS_CREATING_TRUCK](state, status) {
    state.creatingOrderTruck = status
  },
  [types.RESET_DATA_TRUCK](state) {
    Object.assign(state, INITIAL_DATA_TRUCK)
  },
  [types.REUSE_STATE_TO_CREATE_ORDER_TRUCK](state, newState) {
    Object.assign(state, newState)
  },
  [types.PREV_PATH_OF_ORDER_DETAIL_TRUCK](state, path) {
    state.prevPathOfOrderDetail = path
  },
  [types.SET_ORDER_FORM_PAYMENT_METHOD_TRUCK](state, data) {
    state.payment_method = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
